/* eslint-disable jsdoc/require-returns */
/**
 * Numeric Range.
 *
 * @private
 */
export class DoubleRange {
    //private mIsEmpty: boolean;
    /** @private */
    get start() {
        return this.mStart;
    }
    /** @private */
    get end() {
        return this.mEnd;
    }
    /*
      get isEmpty(): boolean {
         return this.mIsEmpty;
     }*/
    /** @private */
    get delta() {
        return (this.mEnd - this.mStart);
    }
    /** @private */
    get median() {
        return this.mStart + (this.mEnd - this.mStart) / 2;
    }
    constructor(start, end) {
        /*
          if (!isNaN(start) && !isNaN(end)) {
           this.mIsEmpty = true;
          } else {
              this.mIsEmpty = false;
          }*/
        if (start < end) {
            this.mStart = start;
            this.mEnd = end;
        }
        else {
            this.mStart = end;
            this.mEnd = start;
        }
    }
}
